import { Tenant } from "store/environments/environment-types";

export enum ScheduleIntervalType {
    TimeOfDay = 0,
    Minutes = 1,
}

export interface SchedulerTime {
    id?: string;
    intervalInMinutes: number | null;
    intervalType: ScheduleIntervalType;
    lastStarted: string | null;
    timeOfDay: string | null;
    weekdays: number | null;
}
export interface ScheduleEvent {
    enabled: boolean;
    event: ScheduleEventType;
    id?: string;
    scheduleTimes: SchedulerTime[];
    subtype: ScheduleEventSubtype;
}

export enum ScheduleEventType {
    Email = 0,
    AxImport = 1,
    VendorPrepaymentRegisterCheck = 2,
    InvoiceWaitingForPrCheck = 3,
    MachineLearningModelReTraining = 4,
    RecurringInvoices = 5,
    InvoiceForInformation = 6,
    InvoiceEscalation = 7,
}

export enum ScheduleEventSubtype {
    OpenInvoiceEmail = 0,
    OnHoldMonthlyInvoiceEmail = 1,
    OnHoldDueDateInvoiceEmail = 2,
}

export type TPromise = [Tenant<ScheduleEvent> | null, number];
